import { gql } from 'urql'

export const fetchPfKapProjectsGrid = gql`
  query ($isGfsUser: Boolean!) {
    pf_kap_project {
      id
      modules
      application_type {
        key
        code
      }
      project_base {
        gfch_responsible {
          first_name
          last_name
        }
        dossier {
          id
          type
          short_title
          status
          description
          start_date
          end_date
          funding_round {
            id
            name
          }
          first_open_milestone @include(if: $isGfsUser) {
            type
            year_in_focus
          }
        }
        user {
          first_name
          last_name
        }
      }
    }
  }
`

export const fetchPfPgvProjectsGrid = gql`
  query ($isGfsUser: Boolean!) {
    pf_pgv_project {
      id
      application_type {
        key
        code
      }
      project_base {
        gfch_responsible {
          first_name
          last_name
        }
        dossier {
          id
          type
          short_title
          status
          description
          start_date
          end_date
          funding_round {
            id
            name
          }
          first_open_milestone @include(if: $isGfsUser) {
            type
            year_in_focus
          }
        }
        user {
          first_name
          last_name
        }
      }
    }
  }
`

export const fetchGfchResponsibleUsersForProcessQuery = gql`
  query fetchGfchResponsibleUsersForProcess($dossierType: String!) {
    project_base(
      where: { _and: { dossier: { type: { _eq: $dossierType } }, gfch_responsible: { id: { _is_null: false } } } }
      distinct_on: gfch_responsible_id
    ) {
      gfch_responsible_id
      gfch_responsible {
        first_name
        last_name
      }
    }
  }
`
